import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react';
import { FC, ReactNode } from 'react';
import ChevronRightIcon from '@/assets/chevron-right.svg';
import { ButtonWithForwardRef } from './ui/button';

export type AccordionProps = {
  id: string | number;
  children: ReactNode;
  title: string;
  open?: boolean;
};

export const Accordion: FC<AccordionProps> = ({
  children,
  id,
  open,
  title,
}) => (
  // Programmatically opening the disclosure after initial render is currently not supported.
  // So workaround is getting the ref to the collapse button and pressing it in a useEffect...
  <Disclosure
    as="div"
    className="rounded-md"
    defaultOpen={open}
    key={`${id}-${open ? 'open' : 'closed'}`}
  >
    <DisclosureButton
      as={ButtonWithForwardRef}
      className="group flex w-full flex-row items-center gap-1 rounded-md py-3"
      variant="unstyled"
    >
      <ChevronRightIcon className="size-5 fill-white/60 group-data-hover:fill-white/50 group-data-open:rotate-90" />
      <span className="text-base font-semibold">{title}</span>
    </DisclosureButton>
    <DisclosurePanel className="mt-2 text-sm/5 text-white/50">
      {children}
    </DisclosurePanel>
  </Disclosure>
);
